module.exports = __webpack_public_path__ + "static/img/cv_rousseau_kevin_fr.3b353af.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cv_rousseau_kevin_fr.pdf
// module id = u+oR
// module chunks = 1